export default {
  eyebrow: 'Partner-Portal',
  title: 'Konto',
  description: 'Die Kontodaten Ihres Partnerkontos.',
  page: {
    read_only_notice: 'Nur Lesezugriff. Klicken Sie auf Bearbeiten, um Werte zu ändern.',
    editing_notice: 'Bearbeitung — Änderungen sind für Ihr Team und Ihre Kunden sichtbar.',
  },
  profile: {
    form: {
      name: {
        label: 'Partnername',
        hint: 'Der rechtliche / Firmenname. Wird auf Abrechnungsdokumenten verwendet.',
      },
      display_name: {
        label: 'Anzeigename für Kunden',
        hint: 'Das „Powered by ___“-Label, das Ihre Kunden in Ihren Restaurants sehen. Entspricht standardmäßig dem Partnernamen.',
      },
      support_email: {
        label: 'Kontakt-E-Mail',
        hint: 'Hier erreichen FoodAmigos und Ihre Kunden Sie. Ihre Login-E-Mail bleibt unverändert.',
      },
      invoicing_emails: {
        label: 'Rechnungs-E-Mails',
        hint: 'Belege für Rechnungen an Sie gehen an jede dieser Adressen. Leer lassen, um Ihre Login-E-Mail zu verwenden.',
        placeholder: 'Ihre Login-E-Mail',
      },
    },
  },
  buttons: {
    edit: 'Bearbeiten',
    cancel: 'Abbrechen',
    save: 'Speichern',
  },
  toasts: {
    load_error: 'Ihre Kontodaten konnten nicht geladen werden.',
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    changes_got_saved: 'Änderungen wurden gespeichert',
  },
};
